import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnDestroy, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-play-audio-button',
  standalone: true,
  imports: [],
  templateUrl: './play-audio-button.component.html',
})
export class PlayAudioButtonComponent implements OnDestroy {
  @Input() url = '';
  @Input() label = 'Play Sample';

  isPlaying = false;
  private audio: HTMLAudioElement | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  togglePlay(): void {
    if (!isPlatformBrowser(this.platformId) || !this.url) return;

    if (!this.audio) {
      this.audio = new Audio(this.url);
      this.audio.addEventListener('ended', () => {
        this.isPlaying = false;
      });
    }

    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
    } else {
      this.audio.play().then(() => {
        this.isPlaying = true;
      });
    }
  }

  ngOnDestroy(): void {
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
  }
}
